module.exports = __webpack_public_path__ + "static/media/new_logo.40ea153e.jpg";